import { css, polished } from 'jimu-core';
export function expressionEditorStyles(props) {
    const theme = props.theme;
    return css `
    .component-expression-editor{
      .mt-18{
        margin-top: 18px;
      }
      .jimu-nav.nav.nav-pills.nav-fill{
        border-top: 0;
        border-left: 0;
        border-right: 0;
      }
      .expression-editor-input{
        -webkit-user-select: text !important;
        user-select: text !important;
        font-size: 13px;
        font-weight: 400;
        overflow-x: hidden;
        overflow-y: auto;
        min-height: ${polished.rem(48)};
        max-height: ${polished.rem(100)};
        user-select: none;
        border: 0;
        outline: none;
        background-color: ${theme.ref.palette.neutral[300]};
        padding: 1px;
        .expression-editor-input-content-editable:focus{
          border-color: ${theme.sys.color.primary.dark};
          outline: none;
        }
        .expression-editor-input-content-editable{
          border: 1px solid ${theme.ref.palette.neutral[300]};
          min-height: ${polished.rem(48)};
          max-height: ${polished.rem(100)};
          border-radius: 2px;
          outline: none;
        }
        p{
          min-height: 100%;
        }
        .break-all{
          word-break: break-all;
        }
        span.error-exp{
          color: ${theme.sys.color.error.light};
        }
        .field-exp{
          color: ${theme.sys.color.warning.light};
        }
        .function-exp{
          color: ${theme.sys.color.primary.light};
        }
        .number-exp{
          color: ${theme.sys.color.info.main};
        }
        .string-exp{
          color: ${theme.sys.color.success.light};
        }
        .operator-exp{
          color: ${theme.ref.palette.neutral[1100]};
        }
        .order-exp{
          color: ${theme.ref.palette.success[500]};
        }
        .unknown-exp{
          color: ${theme.sys.color.error.light};
        }
        .ds-disabled-exp{
          color: ${theme.sys.color.error.light};
        }
      }

      .error-border{
        border: 1px solid #FF5066;
        outline: none;
        .expression-editor-input-content-editable{
          outline: none;
          border: 0;
        }
      }

      .expression-editor-function-item{
        border: 1px solid transparent;
        cursor: pointer;
        background-color: ${theme.ref.palette.neutral[500]};
        user-select: none;
      }
      .expression-editor-function-item-selected{
        border: 1px solid ${theme.sys.color.primary.main};
      }
      .expression-editor-function-item:hover{
        background-color: ${theme.ref.palette.neutral[500]};
      }
      .expression-editor-function-item:active.expression-editor-function-item:hover{
        background-color: ${theme.ref.palette.white};
      }

      .exp-editor-helper{
        user-select: none;
      }
      .with-error-message .exp-editor-helper .component-field-selector .field-list{
        height: calc(100% - 185px);
      }
      .exp-editor-helper-tab{
        margin-left: -16px;
        margin-right: -16px;
      }

      .error-message{
        height: 20px;
        line-height: 20px;
      }

      .exp-popper{
        background-color: ${theme.ref.palette.neutral[300]};
        border: 1px solid ${theme.ref.palette.neutral[700]};
        font-size: 13px;
        width: ${polished.rem(200)};
        z-index: 1;
        padding: 0 !important;
        box-shadow: 0 0 8px 0 ${polished.rgba(theme.ref.palette.white, 0.5)};
        .exp-popper-item{
          padding-left: 8px;
          padding-right: 8px;
        }
        .jimu-popper--arrow::after {
          border-bottom-color: ${theme.ref.palette.neutral[300]} !important;
        }
      }
      .exp-popper-selected-item, .exp-popper-item:hover{
        background-color: ${theme.sys.color.secondary.main};
        cursor: pointer;
      }

    }

  `;
}
